function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_camera"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m6 9c-.26 0-.52.11-.71.291-.181.192-.29.453-.29.715s.109.522.29.715c.38.372 1.04.372 1.42 0 .18-.193.29-.453.29-.715s-.11-.523-.29-.715c-.19-.181-.45-.291-.71-.291z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 6h-2.382l-.724-1.447c-.169-.339-.515-.553-.894-.553h-5c-.552 0-1 .447-1 1s.448 1 1 1h4.382l.724 1.447c.169.339.515.553.894.553h3c.551 0 1 .448 1 1v7c0 .553.448 1 1 1s1-.447 1-1v-7c0-1.654-1.346-3-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.331 2.331c-1.476.188-2.624 1.437-2.624 2.962v8c0 1.654 1.346 3 3 3h13.586l1.707 1.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm6.695 9.523 2.781 2.781c-.335.251-.74.403-1.183.403-1.103 0-2-.897-2-2 0-.443.152-.848.402-1.184zm-5.402 6.184c-.551 0-1-.448-1-1v-8c0-.552.449-1 1-1h1.586l2.388 2.388c-.619.711-.974 1.624-.974 2.612 0 2.206 1.794 4 4 4 .987 0 1.901-.355 2.612-.974l1.974 1.974z"
})));

var Svg069Nocamera = function Svg069Nocamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg069Nocamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/069-no camera.417557dd.svg";
export { ForwardRef as ReactComponent };